const SignIn = ({ handleSignIn, signingUp, handleSignUp, userZoomInfo, handleResetPassword }) => {
  return (
    <div>
      {
        !signingUp ?
          <form className='sign-in' onSubmit={(e) => handleSignIn(e)}>
            <label>
              Email
              <input className='secondary' type="text" name="email" autoComplete='off' />
            </label>
            <label>
              Password
              <input className='secondary' type="password" name="password" />
            </label>
            <button className='main-btn'>Sign In</button>
            <div>Don't have an account?
              <a
                href={process.env.REACT_APP_ZOOM_SIGNUP_URI}>
                Sign Up
              </a>
            </div>
            <div>
              Forgot your password? <span className='url' onClick={() => handleResetPassword()}>Click here</span> to reset it.
            </div>
            <div>
              Need help using the tool? Visi our<a href="https://getcreel.com/docs.html">Docs</a> page.
            </div>
          </form>
          : userZoomInfo ?
            <form className='sign-in' onSubmit={(e) => handleSignUp(e)}>
              <h1>Welcome {userZoomInfo.first_name}!</h1>
              <label>
                Zoom email
                <div style={{ fontSize: '1.2rem' }}>{userZoomInfo.email}</div>
              </label>
              <label>
                Password
                <input className='secondary' type="password" name="password" />
              </label>
              <label>
                Confirm Password
                <input className='secondary' type="password" name="confirm" />
              </label>
              <button className='main-btn'>Sign Up</button>
            </form>
            :
            <div>Loading...</div>
      }
    </div>
  );
}

export default SignIn;